const style = {
  cardWrapper: {
    width: "100%",
    left: 0,
    right: 0,
    p: 2,
    display: "flex",
    alignItems: "center",
    marginLeft: "auto",
    marginRight: "auto",
    justifyContent: "space-between",
    border: "1px solid",
    borderColor: "primary.main",
    rowGap: "16px",
  },
  box1: {
    display: "flex",
    columnGap: "16px",
  },
  box2: {
    display: "flex",
    columnGap: "16px",
    rowGap: "16px",
    width: "100%",
    justifyContent: "space-between",
  },
  buttonOutline: {
    color: "#333333",
    borderColor: "#333333",
  },
  dialogBox: {
    minHeight: "400px",
    maxWidth: "none",
    borderRadius: 0,
  },
  dialogTitleBox: {
    borderBottom: "1px solid #E9E8E8",
  },
  dialogTitleWrapper: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  dialogText: {
    fontSize: "18px",
    fontWeight: "700",
    lineHeight: 1,
  },
  iconColor: { color: "#2C2C2C" },
  dialogContent: {
    margin: "24px 0",
  },
  dialogAction: {
    borderTop: "1px solid #E9E8E8",
    padding: "20px 24px",
    display: "flex",
    columnGap: "16px",
    alignItems: "center",
  },
};

export default style;
